import { create } from "zustand";

interface FormState {
  isEditing: boolean;
  editableMode: boolean;
}

interface EditableFormState {
  forms: Record<string, FormState>;
  isEditing: boolean;
  editableMode: boolean;
  startEditing: (id?: string) => void;
  cancelEditing: (id?: string) => void;
  setIsEditing: (value: boolean, id?: string) => void;
  setEditableMode: (value: boolean, id?: string) => void;
}

const DEFAULT_ID = "default";

export const useEditableForm = create<EditableFormState>((set, get) => ({
  forms: {},
  isEditing: false,
  editableMode: false,

  startEditing: (id = DEFAULT_ID) => {
    if (id === DEFAULT_ID) {
      set({ isEditing: true });
    } else {
      set((state) => ({
        forms: {
          ...state.forms,
          [id]: { ...state.forms[id], isEditing: true },
        },
      }));
    }
  },

  cancelEditing: (id = DEFAULT_ID) => {
    if (id === DEFAULT_ID) {
      set({ isEditing: false });
    } else {
      set((state) => ({
        forms: {
          ...state.forms,
          [id]: { ...state.forms[id], isEditing: false },
        },
      }));
    }
  },

  setIsEditing: (value: boolean, id = DEFAULT_ID) => {
    if (id === DEFAULT_ID) {
      set({ isEditing: value });
    } else {
      set((state) => ({
        forms: {
          ...state.forms,
          [id]: { ...state.forms[id], isEditing: value },
        },
      }));
    }
  },

  setEditableMode: (value: boolean, id = DEFAULT_ID) => {
    if (id === DEFAULT_ID) {
      set({ editableMode: value });
    } else {
      set((state) => ({
        forms: {
          ...state.forms,
          [id]: {
            isEditing: false,
            editableMode: value,
          },
        },
      }));
    }
  },
}));
